const BRT_OFFSET_HOURS = -3;

function getBRTDate(daysOffset: number = 0): string {
    const now = new Date();
    // Convert current UTC time to BRT by adding the BRT offset
    const utcMs = now.getTime() + now.getTimezoneOffset() * 60000;
    const brtMs = utcMs + BRT_OFFSET_HOURS * 3600000;
    const brt = new Date(brtMs);
    brt.setDate(brt.getDate() + daysOffset);
    const year = brt.getFullYear();
    const month = (brt.getMonth() + 1 < 10 ? '0' : '') + (brt.getMonth() + 1);
    const day = (brt.getDate() < 10 ? '0' : '') + brt.getDate();
    return `${year}-${month}-${day}`;
}

export const today = (): string => getBRTDate(0);
export const tomorrow = (): string => getBRTDate(1);
export const dayAfterTomorrow = (): string => getBRTDate(2);
export const threeDaysFromNow = (): string => getBRTDate(3);

export function getNextNDays(n: number, startOffset: number = 0): string[] {
    const dates: string[] = [];
    for (let i = startOffset; i < startOffset + n; i++) {
        dates.push(getBRTDate(i));
    }
    return dates;
}

export const ofdDateOptions = (): string[] => [tomorrow(), dayAfterTomorrow()];

export const tacticalCapsDateOptions = (): string[] => getNextNDays(7, 0);
